<template>
  <transition name="backdrop">
    <div class="full-screen-backdrop">
      <div class="full-screen-backdrop-anchor-el">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'fullScreenBackdrop',
};
</script>

<style lang="scss" scoped>
  $modal-backdrop-color: rgba($context-color-1-rgb, 0.2); // THIS IS GENERAL
  .full-screen-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 25;
    background-color: $modal-backdrop-color;
    transition: opacity 0.3s ease;

    .full-screen-backdrop-anchor-el {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  .backdrop-enter {
    opacity: 0;
  }

  .backdrop-leave-active {
    opacity: 0;
  }
</style>
